import {Component,EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl,UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { AlertBannerService ,AlertType} from 'src/app/lib/alert-banner';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import {PermissionsService} from "../../services/permissions/permissions.service";
@Component({
  selector: 'app-candidate-referee-notes-modal',
  templateUrl: './candidate-referee-notes-modal.component.pug',
  styleUrls: ['./candidate-referee-notes-modal.component.scss'],
  standalone: false
})
export class CandidateRefereeNotesModalComponent implements OnInit {

  @ViewChild('candidateField') candidateText:any = ''
  @ViewChild('refereeField') refereeText:any = ''
  @Output() updateParent:EventEmitter<any> = new EventEmitter()
  CandidateText = 'Please provide the details of the referees who have directly supervised you. You can do this on your mobile device or computer.\nWe encourage you to provide the work email addresses of your referees and to contact them before submitting their details. Your referees will then receive an email with a link to complete your online reference check.'
  RefereeText = 'Thank you for taking the time to complete this reference survey. You can do this on your mobile device or computer.\nPlease provide a comprehensive overview of the candidate’s performance, capability and areas for improvement during their time working with you.';
  org_details:any
  candidateFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH;
  refereeFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH;
  refereeCandidateForm:any
  candidateTooltip = $localize`This customisable message will appear in the email to the candidate and when they nominate their referees.`
  refereeTooltip = $localize`This customisable message will appear in the email to the referee and when they provide their feedback.`
  defaultCandidateText = ' ';
  defaultRefereeText = ' ';
  revertToSystemDefaultMessage = $localize`Revert to system default`;
  disableCandidateRevert = false;
  disableRefereeRevert = false;

  constructor(
    public _bsModalRef: BsModalRef,
    private alertList: AlertBannerService,
    private organisationService: OrganisationService,
    public modal: WarningModalService,
    private permission: PermissionsService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(){

    this.org_details = this.organisationService.getOrganisationDetails()

    this.defaultCandidateText = this.org_details.notes.note_to_candidate
    this.defaultRefereeText = this.org_details.notes.note_to_referee

    this.refereeCandidateForm = new UntypedFormGroup({
      'noteToCandidate':new UntypedFormControl(null),
      'noteToReferee':new UntypedFormControl(null)
    })

    this.refereeCandidateForm.get('noteToCandidate').value = this.org_details.notes.note_to_candidate;
    this.refereeCandidateForm.get('noteToReferee').value = this.org_details.notes.note_to_referee;
    this.candidateFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - this.defaultCandidateText.length;
    this.refereeFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - this.defaultRefereeText.length;

    this.disableCandidateRevert = this.org_details.notes.note_to_candidate == this.CandidateText;
    this.disableRefereeRevert = this.org_details.notes.note_to_referee == this.RefereeText;
  }


  candidateFieldEvent(event){
    const typedText = this.candidateText.nativeElement.value.length;
    this.candidateFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - typedText;
    this.disableCandidateRevert = this.candidateText.nativeElement.value == this.CandidateText;
  }
  refereeFieldEvent(event){
    const typedText = this.refereeText.nativeElement.value.length;
    this.refereeFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - typedText;
    this.disableRefereeRevert = this.refereeText.nativeElement.value == this.RefereeText;
  }

  cancel(){
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.refereeCandidateForm.reset();
        this._bsModalRef.hide();
      }
    });
  }
  canDeactiveRevert():Observable<boolean>{
      let title = $localize`Revert to system default? `;
      let message = $localize`By reverting to the system default, all changes will be lost.\n\nAre you sure you want to continue?  `;
      let cancelButton = $localize`Cancel`;
      let agreeButton = $localize`Yes`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton);
  }
  canDeactivate(): Observable<boolean> {
    // If component is dirty, warn user
    if (this.isDirty()) {
      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton);
    } else {
      return of(true);
    }
  }

  isDirty(): boolean {
    return this.refereeCandidateForm.dirty;
  }

  updateOrganisation(org_uid, payload){

    return this.organisationService.updateOrganisationNotes(payload).subscribe(
        res => {
          if (res.data.message == 'saved successfully') {
            this.org_details.notes = res.data.object.config
            this.initializeForm()
          }
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
          }]);
          this._bsModalRef.hide()
        }, err => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong.`,
            keepOnRouteChange: true
          }]);
          this._bsModalRef.hide()
        }
      )
    }
  onSubmit(){
    const org_uid = this.org_details.uid
    const payload = {
      "config":{
        "note_to_candidate":this.refereeCandidateForm.get('noteToCandidate').value,
        "note_to_referee":this.refereeCandidateForm.get('noteToReferee').value
      }
    }
    this.updateOrganisation(org_uid, payload)
  }
  revertToDefault(field){
    this.canDeactiveRevert().subscribe(
      res=>{
        if(res){
          if(field=='referee'){
            this.refereeText.nativeElement.value = this.RefereeText;
            this.refereeCandidateForm.get('noteToReferee').value = this.RefereeText;
            this.refereeFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - this.RefereeText.length;
            this.disableRefereeRevert = true;
          }else{
            this.candidateFieldLength = ConstantsService.CANDIDATE_REFEREE_TEXT_LENGTH - this.CandidateText.length;
            this.candidateText.nativeElement.value = this.CandidateText
            this.refereeCandidateForm.get('noteToCandidate').value = this.CandidateText;
            this.disableCandidateRevert = true;
          }
        }
      }
    )
  }
}
